import { SpeedDialerStatus } from '../types/speed-dialer.type';

/**
 * Valid state transitions for the speed dialer
 */
const validTransitions: Record<SpeedDialerStatus, SpeedDialerStatus[]> = {
  idle: ['active'],
  active: ['paused', 'processing_call', 'idle'],
  paused: ['active', 'idle', 'processing_call'],
  processing_call: ['call_in_progress', 'active', 'idle', 'paused'],
  call_in_progress: ['active', 'idle', 'paused', 'processing_call'],
};

/**
 * Checks if a state transition is valid
 * @param current Current state
 * @param next Next state
 * @returns Whether the transition is valid
 */
export const isValidStateTransition = (
  current: SpeedDialerStatus,
  next: SpeedDialerStatus
): boolean => {
  return validTransitions[current].includes(next);
};
